:host {
  display: block;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  --color-text-secondary: #6b7280;
}

/* Theme support for indicators */
:host([theme="dark"]) {
  --color-text-secondary: #9ca3af;
}

/* Set theme variables */
:host([theme="dark"]) {
  --color-text-secondary: #9ca3af;
  --color-background: #1f2937;
  --color-text: #f9fafb;
}

:host([theme="light"]) {
  --color-text-secondary: #6b7280;
  --color-background: #ffffff;
  --color-text: #111827;
}

summary::before {
  content: '►';
  position: absolute;
  left: 0;
  font-size: 0.75rem;
  color: var(--color-text-secondary);
  transform: rotate(0);
  transition: transform 0.2s;
}

details[open] > summary::before {
  transform: rotate(90deg);
}
